import React, { forwardRef } from 'react';

import { usePopoverContext } from '@lyearn/ui';

import AddMoreButton from './AddMoreButton';

interface Props {
  className?: string;
  children: string | React.ReactNode;
  isSelected?: boolean;
}

const AddMoreButtonContainer = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { children, isSelected, ...rest } = props;
  // TODO: since we are using children in suspense fallback, we need to pass showError: false to the popover
  const popover = usePopoverContext({ showError: false });
  const isOpen = popover?.open;

  return (
    <AddMoreButton ref={ref} isOpen={isOpen} isSelected={isSelected} {...rest}>
      {children}
    </AddMoreButton>
  );
});

export default AddMoreButtonContainer;
